import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import * as exifr from 'exifr';
import { Nevera } from '../nevera.model';
import { NeverasService } from '../neveras.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-neveras',
  templateUrl: './edit-neveras.component.html',
  styleUrls: ['./edit-neveras.component.scss'],
})
export class EditNeverasComponent implements OnInit {
  public subscriptions: Subscription[] = [];

  public errorMessage = '';
  private neveraID = '';
  public isLoading = false;
  public imageLoading = false;
  public mode = 'create';
  public edited = false;
  public tiposAlimento: any;
  public ingredientes: any;
  public ingredientesDescription: any;
  public condimentos: any;
  public condimentosDescription: any;
  public tipo = '';
  public nevera: Nevera = {
    nevera_id: '',
    nevera_date: '',
    nevera_date_full: '',
    url_slug: '',
    created_by: '',
    modified_by: '',
    latitud: '',
    longitud: '',
    ciudad: '',
    ciudad_slug: '',
    pais: '',
    pais_slug: '',
    images: [{ image_path: null, preview: null, tipo_id: 1, sort_id: 1 }],
  };

  constructor(
    private neverasService: NeverasService,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];

    window.scroll(0, 0);
    this.isLoading = true;
    this.isLoading = false;

    this.newImagenes();

    this.subscriptions.push(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        if (paramMap.has('url_slug')) {
          this.mode = 'edit';
          this.getNeveraDetails(paramMap);
        } else {
          this.mode = 'create';
        }
      })
    );
  }

  private getNeveraDetails(paramMap: ParamMap): void {
    this.subscriptions.push(
      this.neverasService.getNevera(paramMap.get('url_slug') || '').subscribe(
        (response) => {
          // console.log('nevera a editar: ', response);
          this.nevera = response[0];
          if (!this.nevera) {
            this.router.navigate(['/neveras'], {
              state: {
                data: 'Lo sentimos, no se ha podido encontrar el nevera especificado.',
              },
            });
          }
          if (this.nevera.nevera_id) {
            this.getImagenes(this.nevera.nevera_id);
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 50);

          const date = this.nevera.nevera_date;
          this.nevera.nevera_date_full = new NgbDate(
            Number(date.substr(0, 4)),
            Number(date.substr(5, 2)),
            Number(date.substr(8, 2))
          );
          // this.nevera.images = response[0].image_path;
          // this.imagePreview = environment.imageBaseURL + this.nevera.images;
          console.log(
            'this.nevera.nevera_date_full: ',
            this.nevera.nevera_date_full
          );
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        }
      )
    );
  }

  private getImagenes(neveraID: string): void {
    this.subscriptions.push(
      this.neverasService.getImagenes(neveraID).subscribe(
        (result) => {
          // console.log(result);
          this.nevera.images = result;
          for (let i = 0; i < this.nevera.images.length; i++) {
            /*this.imagePreview.push(
            environment.imageBaseURL + this.nevera.images[i].image_path
          );*/
            console.log('Cargando imagen: ', i);
            this.nevera.images[i].preview =
              environment.imageBaseURL + this.nevera.images[i].image_path;

            // console.log('Cargando imagen (preview): ', this.nevera.images[i].preview);
          }
          // console.log('this.nevera.images:');
          // console.log(this.nevera.images);
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        }
      )
    );
  }

  onSubmit(form: NgForm): void {
    if (!form.invalid) {
      this.nevera.nevera_date = this.ngbDateParserFormatter.format(
        form.value.nevera_date_full
      );
      this.nevera.latitud = form.value.latitud
        ? form.value.latitud
        : this.nevera.latitud;
      this.nevera.longitud = form.value.longitud
        ? form.value.longitud
        : this.nevera.longitud;
      this.nevera.ciudad = form.value.ciudad
        ? form.value.ciudad
        : this.nevera.ciudad;
      this.nevera.pais = form.value.pais ? form.value.pais : this.nevera.pais;

      this.nevera.ciudad_slug = this.nevera.ciudad
        ? this.stringToSlug(this.nevera.ciudad)
        : '';
      this.nevera.pais_slug = this.nevera.pais
        ? this.stringToSlug(this.nevera.pais)
        : '';

      if (this.mode === 'create') {
        this.nevera.created_by = this.authService.getUserID();

        // Creates a random number between 1 and 1000000
        const rand = Math.floor(Math.random() * 1000000 + 1).toString();

        this.nevera.url_slug = this.nevera.nevera_date
          ? this.nevera.nevera_date + '-' + rand
          : rand;
      } else {
        this.nevera.url_slug = this.nevera.url_slug.substring(
          this.nevera.url_slug.lastIndexOf('-'),
          this.nevera.url_slug.length
        );
        console.log('Trimming url: ', this.nevera.url_slug);
        this.nevera.url_slug = this.nevera.nevera_date + this.nevera.url_slug;
        console.log('Trimming url final: ', this.nevera.url_slug);
      }
      this.nevera.modified_by = this.authService.getUserID();

      console.log('Form: ', form);
      console.log('Nevera: ', this.nevera);

      if (this.mode === 'create') {
        this.subscriptions.push(
          this.neverasService.newNevera(this.nevera).subscribe(
            (result) => {
              console.log(result);
              console.log('nevera almacenado con éxito: ', result);
              this.errorMessage = 'El nevera ha sido añadido con éxito';
              // this.isLoading = false;
              this.edited = true;
              this.nevera.nevera_id = result.id ? result.id : '';
              console.log('Nueva nevera ID: ', this.nevera.nevera_id);

              this.uploadImages(this.nevera.images);
            },

            (error) => {
              console.log(error);
              this.isLoading = false;
              this.imageLoading = false;
              this.errorMessage =
                error.error.error.message ||
                'Lo sentimos, se ha producido un error.';
            }
          )
        );
      } else if (this.mode === 'edit') {
        this.subscriptions.push(
          this.neverasService.updateNevera(this.nevera).subscribe(
            (result) => {
              console.log('La nevera ha sido actualizada con éxito.');
              this.errorMessage = 'Nevera actualizada correctamente';
              // this.isLoading = false;
              this.edited = true;

              this.uploadImages(this.nevera.images);
            },

            (error) => {
              this.isLoading = false;
              this.imageLoading = false;
              console.log(error);
              this.errorMessage =
                error.error.error.message ||
                'Lo sentimos, se ha producido un error.';
              window.scroll(0, 0);
            }
          )
        );
      }
    }
  }

  private uploadImages(images: any): void {
    this.subscriptions.push(
      this.neverasService.unlinkImages(this.nevera.nevera_id).subscribe(
        (result) => {
          console.log('Las imágenes han sido desenlazadas con éxito.');

          // console.log('Subiendo imégenenes: ', images);
          this.imageLoading = true;
          images.forEach((image: any, i: number) => {
            if (image && !image.preview) {
              images.splice(i, 1);
            }
          });
          images.forEach((image: any, i: number) => {
            if (image && image.preview) {
              this.uploadEachImage(image, i, i === images.length - 1);
            } else {
              i++;
            }
          });
        },
        (error) => {
          this.isLoading = false;
          this.imageLoading = false;
          console.log(error);
          this.errorMessage =
            error.error.error.message ||
            'Lo sentimos, se ha producido un error al subir las imágenes.';
          window.scroll(0, 0);
        }
      )
    );
  }

  private uploadEachImage(image: any, id: number, isLast: boolean): void {
    this.imageLoading = true;
    console.log('Subiendo imagen: ', id, ', ', isLast);
    this.subscriptions.push(
      this.neverasService
        .uploadImage(
          this.nevera.nevera_id,
          image.image_path,
          this.nevera.url_slug,
          image.tipo_id,
          '' + (id + 1)
        )
        .subscribe(
          (result) => {
            console.log('La nevera ha sido actualizada con éxito.');
            if (isLast) {
              this.isLoading = false;
              this.edited = true;
              this.imageLoading = false;
              const message =
                this.mode === 'create'
                  ? 'Nevera añadida correctamente'
                  : 'Nevera actualizada correctamente';

              setTimeout(() => {
                this.router.navigate(['/neveras'], {
                  state: { data: message, bypassConfirmation: true },
                });
              }, 3000);
            }
          },
          (error) => {
            this.isLoading = false;
            this.imageLoading = false;
            console.log(error);
            this.errorMessage =
              error.error.error.message ||
              'Lo sentimos, se ha producido un error al subir las imágenes.';
            window.scroll(0, 0);
          }
        )
    );
  }

  onAddImagen(): void {
    this.nevera.images.push({
      image_path: '',
      preview: null,
      tipo_id: 1,
      sort_id: 1,
    });
    console.log('Images after push: ', this.nevera.images);
    //this.imagenesEmpty = false;

    setTimeout(() => {
      console.log('imagePicker_' + (this.nevera.images.length - 1));
      console.log(
        document.getElementById(
          'imagePicker_' + (this.nevera.images.length - 1)
        )
      );
      document
        .getElementById('imagePicker_' + (this.nevera.images.length - 1))
        ?.click();
    }, 50);
  }

  onImagePicked(event: Event, i: number): void {
    // console.log(event);
    const fileArray: any = (event.target as HTMLInputElement).files
      ? (event.target as HTMLInputElement).files
      : null;
    if (fileArray && fileArray.length) {
      this.nevera.images[i].image_path = fileArray[0];
      // console.log('this.nevera.image: ', this.nevera.images);
      const reader = new FileReader();
      reader.onload = () => {
        // this.imagePreview[i] = reader.result;
        this.nevera.images[i].preview = reader.result;
        if (!this.nevera.latitud || !this.nevera.longitud) {
          this.getCoordinates(this.nevera.images[i].preview);
        }
      };
      reader.readAsDataURL(this.nevera.images[i].image_path);
    }
  }
  onDeleteImagen(i: number): void {
    this.nevera.images.splice(i, 1);
    if (this.nevera.images.length === 0) {
      this.newImagenes();
    }
  }

  private newImagenes(): void {
    this.nevera.images = [];
    this.nevera.images.push({
      image_path: null,
      preview: null,
      tipo_id: 1,
      sort_id: 1,
    });
    //this.imagenesEmpty = true;
  }

  processURLSlug(): string {
    console.log('Procesando URL slug');
    /*if (this.tipo && this.nevera.nevera_despensa_date_full) {

      } else {
        return (
          this.tipo +
          '-' +
          this.stringToSlug(
            this.ngbDateParserFormatter.format(
              this.nevera.nevera_despensa_date_full
            )
          ) // date
        );
      }
    }*/
    return '';
  }

  private stringToSlug(input: string): string {
    if (input) {
      const trChars: any = {
        áÁ: 'a',
        éÉ: 'e',
        íÍ: 'i',
        óÓ: 'o',
        úÚ: 'u',
        ñÑ: 'n',
      };
      for (const key of Object.keys(trChars)) {
        input = input.replace(new RegExp('[' + key + ']', 'g'), trChars[key]);
      }

      return input
        .toString()
        .toLowerCase()
        .replace(/ de /g, '-')
        .replace(/ con /g, '-')
        .replace(/ y /g, '-')
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    }
    return '';
  }
  public getCoordinates(image: any): void {
    // console.log('Imagen a procesar para coordenadas PRE: ', image);
    if (
      !image &&
      this.nevera.images &&
      this.nevera.images[0] &&
      this.nevera.images[0].image_path
    ) {
      image = '/assets' + this.nevera.images[0].image_path;
    }
    // console.log('Imagen a procesar para coordenadas POST: ', image);
    if (image) {
      exifr.gps(image).then((gps) => {
        this.nevera.latitud = gps.latitude.toString();
        this.nevera.longitud = gps.longitude.toString();

        console.log(this.nevera.latitud, this.nevera.longitud);

        this.getGeolocationInfo(gps.latitude, gps.longitude);

        /*.subscribe(
            (response) => {
              console.log('GEO GMAPS response: ', response);
            },
            (error) => {
              this.errorMessage = error;
            }
          );*/
      });
    }
  }

  private getGeolocationInfo(latitude: number, longitude: number): void {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results: any) => {
        console.log('Result API', results);

        if (results[1]) {
          let country = null;
          let countryCode = null;
          let city = null;
          let cityAlt = null;
          let c;
          let lc;
          let component;
          console.log(results);
          for (let r = 0, rl = results.length; r < rl; r += 1) {
            const result = results[r];
            console.log(result);

            if (
              (!city &&
                (result.types[0] === 'locality' ||
                  result.types[0] === 'postal_code')) ||
              result.types[0] === 'plus_code' ||
              result.types[0] === 'administrative_area_level_4'
            ) {
              for (
                c = 0, lc = result.address_components.length;
                c < lc;
                c += 1
              ) {
                component = result.address_components[c];
                console.log('Component: ', component);

                if (
                  component.types[0] === 'locality' ||
                  component.types[1] === 'locality' ||
                  component.types[2] === 'locality' ||
                  component.types[0] === 'administrative_area_level_4'
                ) {
                  city = component.long_name;
                  break;
                }
              }
            } else if (
              !city &&
              !cityAlt &&
              result.types[0] === 'administrative_area_level_1'
            ) {
              for (
                c = 0, lc = result.address_components.length;
                c < lc;
                c += 1
              ) {
                component = result.address_components[c];

                if (component.types[0] === 'administrative_area_level_1') {
                  cityAlt = component.long_name;
                  break;
                }
              }
            } else if (!country && result.types[0] === 'country') {
              country = result.address_components[0].long_name;
              countryCode = result.address_components[0].short_name;
            }

            if (city && country) {
              break;
            }
          }

          console.log(
            'City: ' +
              city +
              ', City2: ' +
              cityAlt +
              ', Country: ' +
              country +
              ', Country Code: ' +
              countryCode
          );

          this.nevera.ciudad = city;
          this.nevera.pais = country;
        }
      }
    );
  }

  onNavigate(destination: string): void {
    if (destination === 'this') {
      window.location.href = 'neveras/editar/' + this.nevera.url_slug;
    } else {
      // this.router.navigate(['/' + destination]);
    }
  }
}
